import React, {useEffect } from 'react'; 
import LazyLoad from "react-lazyload";
import Header from "../Component/Header";
import { Link } from 'react-router-dom'
const Sports = () => {
    useEffect(() => {
        document.title = 'Sports -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Facilities</li>
                <li>Co-Scholastic Dept</li>
                 <li>Sports</li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> Sports </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-12 facilities">
                   <div class="facilities-img1 left-block"><img class="img-fluid" src="https://webapi.entab.info/api/image/TAFS/public/Images/sports.jpg" alt="TAFS"/></div>
                   <p className="first-letter">The school has vast play areas with special facilities for cricket, football, basketball, artificial climbing wall, etc. Special coaches train the students in these sports.</p>
                </div>
                <div className="hr"></div>
                <div className="col-lg-12 facilities">
                   <div class="facilities-img1 right-block"><img class="img-fluid" src="https://webapi.entab.info/api/image/TAFS/public/Images/sports1.jpg" alt="TAFS"/></div>
                   <p className="first-letter"> 
                   Physical education is an inherent part of the school and it is our endeavor to achieve high development of each child and enhance multiple intelligences. The innate and inherent talent of each child is identified, manifested, and nurtured to perfection. Garnets of activities are organized to enable each child to excel at least in one field.</p>
                </div>
                <div className="hr"></div>
                <div className="col-lg-12 facilities">
                <div class="facilities-img1 left-block"><img class="img-fluid" src="https://webapi.entab.info/api/image/TAFS/public/Images/sports2.jpg" alt="TAFS"/></div>
                <p className="first-letter"> 
                Great emphasis is given to sports and a large number of activities and games are pursued during school hours and special coaching arranged beyond school hours. The school has many national and international players.</p>
             </div>
             <div className="hr"></div>
                <h6>JUNIOR WING</h6>
                <div className="col-xl-4 col-lg-4 col-md-6">
                 <LazyLoad>
                 <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/JUNIORWING.png"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/JUNIORWING.png" className="schoollib img-fluid" alt="TAFS" /></a> 
               </LazyLoad>  
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/JUNIORWING1.jpg"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/JUNIORWING1.jpg" className="schoollib img-fluid" alt="TAFS" /></a> 
              </LazyLoad>  
               </div> 
                <h6>INDOOR SPORTS</h6>
                <div className="col-xl-3 col-lg-4 col-md-6">
                 <LazyLoad>
                 <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/INDOORsports.png"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/INDOORsports.png" className="schoollib img-fluid" alt="TAFS" /></a> 
               </LazyLoad>  
                </div>
                <div className="col-xl-3 col-lg-4 col-md-6">
                <LazyLoad>
                <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/INDOORsports1.png"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/INDOORsports1.png" className="schoollib img-fluid" alt="TAFS" /></a> 
              </LazyLoad>  
               </div>
               <div className="col-xl-3 col-lg-4 col-md-6">
               <LazyLoad>
               <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/INDOORsports2.png"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/INDOORsports2.png" className="schoollib img-fluid" alt="TAFS" /></a> 
             </LazyLoad>  
              </div>
              <div className="col-xl-3 col-lg-4 col-md-6">
              <LazyLoad>
              <a data-magnify="gallery" data-src="" data-group="a" href="https://webapi.entab.info/api/image/TAFS/public/Images/INDOORsports3.png"><img src="https://webapi.entab.info/api/image/TAFS/public/Images/INDOORsports3.png" className="schoollib img-fluid" alt="TAFS" /></a> 
            </LazyLoad>  
             </div> 
            </div>
            </div>
        </div>
     </>
  )
}

export default Sports